var _path, _path2, _ellipse, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.5179 72.8335C85.9636 72.8335 97.0866 63.9916 97.0866 49.1687C97.0866 36.6533 86.9607 26.4727 74.5179 26.4727H31.5687C20.0447 26.4727 9 35.3832 9 50.1374C9 61.4537 17.2765 70.8608 28.0617 72.5607V87.6436C28.0617 90.8662 32.0436 92.4111 34.1873 89.9878L49.3843 72.8335H74.5179ZM74.4244 45.2845C76.8255 45.2845 78.7707 47.2407 78.7707 49.6531C78.7707 52.0654 76.8255 54.0216 74.4244 54.0216C72.0256 54.0216 70.0803 52.0654 70.0803 49.6531C70.0803 47.2407 72.0256 45.2845 74.4244 45.2845ZM31.6599 54.0216C29.2611 54.0216 27.3159 52.0654 27.3159 49.6531C27.3159 47.2407 29.2611 45.2845 31.6599 45.2845C34.0611 45.2845 36.0063 47.2407 36.0063 49.6531C36.0063 52.0654 34.0611 54.0216 31.6599 54.0216ZM53.0433 45.2845C55.4421 45.2845 57.3873 47.2407 57.3873 49.6531C57.3873 52.0654 55.4421 54.0216 53.0433 54.0216C50.6445 54.0216 48.6993 52.0654 48.6993 49.6531C48.6993 47.2407 50.6445 45.2845 53.0433 45.2845Z",
    fill: "#82C4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2177 64.6694H70.8925C63.8452 64.6694 58.1102 70.3133 58.1102 77.2498C58.1102 85.3518 64.3047 90.3658 70.8925 90.3658H85.1275L93.7346 99.8734C94.9383 101.205 97.204 100.37 97.204 98.5729V90.2133C103.312 89.2712 108 84.0574 108 77.7854C108 69.7008 101.822 64.6694 95.2177 64.6694ZM70.9455 79.9393C69.5856 79.9393 68.4838 78.8551 68.4838 77.5168C68.4838 76.1798 69.5856 75.0956 70.9455 75.0956C72.3041 75.0956 73.4058 76.1798 73.4058 77.5168C73.4058 78.8551 72.3041 79.9393 70.9455 79.9393ZM83.0551 79.9393C81.6965 79.9393 80.5948 78.8551 80.5948 77.5168C80.5948 76.1798 81.6965 75.0956 83.0551 75.0956C84.4137 75.0956 85.5154 76.1798 85.5154 77.5168C85.5154 78.8551 84.4137 79.9393 83.0551 79.9393ZM95.166 79.9393C93.8061 79.9393 92.7044 78.8551 92.7044 77.5168C92.7044 76.1798 93.8061 75.0956 95.166 75.0956C96.5247 75.0956 97.6264 76.1798 97.6264 77.5168C97.6264 78.8551 96.5247 79.9393 95.166 79.9393Z",
    fill: "#0688FA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.6062,
    cy: 50.2481,
    rx: 4.67717,
    ry: 5.06693,
    fill: "#55B0FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.0906,
    cy: 50.2481,
    r: 5.06693,
    fill: "#55B0FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.0432,
    cy: 50.2481,
    r: 5.06693,
    fill: "#3997E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/conversation.af6f162f04a39f941af9f76a2d2844c9.svg";
export { ForwardRef as ReactComponent };